import { Link } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { inr } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Trash2, Minus, Plus, ShoppingBag } from "lucide-react";

export default function Cart() {
  const { items, setQty, remove, subtotal, totalBv } = useCart();
  return (
    <div className="min-h-screen bg-sand">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="font-serif text-4xl text-navy" data-testid="cart-title">Your Cart</h1>
        {items.length === 0 ? (
          <div className="mt-10 bg-white border border-border p-16 text-center rounded-sm">
            <ShoppingBag size={40} className="mx-auto text-navy/30" />
            <p className="mt-4 text-navy/60">Your cart is empty.</p>
            <Link to="/products" data-testid="empty-cart-shop" className="mt-6 inline-block bg-navy text-white px-6 py-3 rounded-sm">Browse products</Link>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 bg-white border border-border rounded-sm divide-y divide-border">
              {items.map((it) => (
                <div key={it.product_id} data-testid={`cart-row-${it.product_id}`} className="p-4 flex gap-4 items-center">
                  <img src={it.image} alt="" className="w-20 h-20 object-cover rounded-sm bg-cream" />
                  <div className="flex-1">
                    <div className="font-serif text-lg text-navy">{it.name}</div>
                    <div className="text-xs text-navy/50">{it.sku} · {it.sp} SP</div>
                  </div>
                  <div className="flex items-center border border-border rounded-sm">
                    <button data-testid={`qty-minus-${it.product_id}`} onClick={() => setQty(it.product_id, it.qty - 1)} className="px-2 py-1 hover:bg-cream"><Minus size={12} /></button>
                    <span className="px-3 text-sm">{it.qty}</span>
                    <button data-testid={`qty-plus-${it.product_id}`} onClick={() => setQty(it.product_id, it.qty + 1)} className="px-2 py-1 hover:bg-cream"><Plus size={12} /></button>
                  </div>
                  <div className="w-24 text-right">{inr(it.mrp * it.qty)}</div>
                  <button data-testid={`remove-${it.product_id}`} onClick={() => remove(it.product_id)} className="p-2 text-rose hover:text-rose/70"><Trash2 size={16} /></button>
                </div>
              ))}
            </div>
            <aside className="bg-white border border-border p-6 rounded-sm h-fit">
              <h3 className="font-serif text-2xl text-navy">Summary</h3>
              <div className="mt-6 space-y-3 text-sm">
                <div className="flex justify-between"><span className="text-navy/60">Subtotal</span><span>{inr(subtotal)}</span></div>
                <div className="flex justify-between"><span className="text-navy/60">Total SP</span><span className="text-gold-deep font-medium">{totalBv}</span></div>
                <div className="flex justify-between"><span className="text-navy/60">Shipping</span><span>{subtotal > 999 ? "Free" : inr(49)}</span></div>
                <div className="border-t border-border pt-3 flex justify-between items-baseline text-navy"><span className="font-serif text-xl">Total</span><span data-testid="cart-total" className="text-xl font-extrabold tabular-nums lining-nums">{inr(subtotal + (subtotal > 999 ? 0 : 49))}</span></div>
              </div>
              <Link to="/checkout" data-testid="checkout-btn" className="mt-6 block text-center bg-gold text-navy py-3 hover:bg-gold-deep rounded-sm font-medium">Proceed to Checkout</Link>
            </aside>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
